// 场景令牌，用于标识当前组件的位置请求场景
export const SCENE_TOKEN = 'mcp-tex-hotel-poi-price-comparison';
// 图标资源
export const FIRE_ICON = 'https://p0.meituan.net/ingee/1ef1d357fd512ce9703e159fb8d564bd581.png';
export const POSITION_ICON = 'https://p0.meituan.net/ingee/9f26d7d8be162892a387aed63844542d1059.png';
export const CHILD_ICON = 'https://p0.meituan.net/ingee/75313c7665de932065d17d976b9e12651068.png';
export const PET_ICON = 'https://p0.meituan.net/ingee/adfa09791ddd4d4d37c478d85caeff741079.png';
export const WEICHAT_ICON = 'https://p0.meituan.net/ingee/cbc5b5cacf0e224a987a5d9f872ee759904.png';
export const UN_SELECTED_ICON = 'https://p0.meituan.net/ingee/dbb8362592904dfbae59af32bdbe98eb1018.png';
export const SELECTED_ICON = 'https://p0.meituan.net/ingee/435882a822963458a2972aae640f15231147.png';
// 图片资源
export const PRICE_REDUCTION_BG = 'https://p0.meituan.net/ingee/ae544d3eaa90a6c01a74b1b720aa031d4832.png';
export const PRICE_INCREASE_BG = 'https://p0.meituan.net/ingee/f0e7d124da14a59ba228dd8b89185a832191.png';
export const PRICE_EQUAL_BG = 'https://p0.meituan.net/ingee/b95bf6c5dd1ddef4197b90ab73f2663b4835.png';
export const NO_POI_IMG = 'https://p0.meituan.net/ingee/a3146049dbe840dad1c5038868ec14bd25531.png';
// 业务常量
export const DEFAULT_PAGE_SIZE = 10;
export const FLOW_SOURCE = 6;
// 默认位置信息（北京）
export const DEFAULT_LOCATION = {
    lat: 39.904989,
    lng: 116.405285,
    cityId: 1,
    locateCityId: 1,
    homeSelectedCity: 1
};
